<template>
  <div class="container">
    <h2>Connexion</h2>
    <input type="email" v-model="email" placeholder="Email" />
    <input type="password" v-model="password" placeholder="Mot de passe" />
    <button @click="login">Se connecter</button>
    <button @click="register">Créer un compte</button>
    <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import { auth } from "@/firebaseConfig";
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";

export default defineComponent({
  name: "LoginPage",
  setup() {
    const router = useRouter();
    const email = ref<string>("");
    const password = ref<string>("");
    const errorMessage = ref<string>("");

    const login = async () => {
      try {
        await signInWithEmailAndPassword(auth, email.value, password.value);
        router.push("/dashboard");
      } catch (error: unknown) {
        if (error instanceof Error) {
          errorMessage.value = error.message;
        }
      }
    };

    const register = async () => {
      try {
        await createUserWithEmailAndPassword(auth, email.value, password.value);
        router.push("/dashboard");
      } catch (error: unknown) {
        if (error instanceof Error) {
          errorMessage.value = error.message;
        }
      }
    };

    return { email, password, errorMessage, login, register, router };
  },
});
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 300px;
  margin: auto;
  text-align: center;
}
input {
  margin: 10px 0;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
button {
  margin: 5px;
  padding: 10px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}
button:hover {
  background-color: #0056b3;
}
.error {
  color: red;
  font-size: 14px;
}
</style>
